// extracted by mini-css-extract-plugin
module.exports = {"containerView":"view_containerView__12b3h","status":"view_status__2OqzT","titleView":"view_titleView__zGiUs","amountView":"view_amountView__3ahuO"};